export var blackConfigMap = {
  1: {
    progressTitle: 'Exibição A',
    progressImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/pro_1.png',
    mainBackground: '#00AF2D',

    /** 主图 */
    mainImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/back_f_1.png',
    // 标题，但是是图片
    themeTitle: 'A VOZ DA LUTA',
    appointmentTitle: 'A voz da luta',
    // 关注按钮的背景颜色
    buttonBackground: '#FECD0F',
    appointmentDateColor: '#FFD74B',
    postTitle: 'GERAR UM PÔSTER POR FINALIZAR A VISITA',
    bottomImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/bot_1.png',
    postFinalImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/fina_1.png',
    // postFinalImg:'https://s1-12726.ap4r.com/oversea-cc-upload/OCC_nNljZBbT_icon-kwai.jpg',
    postFinalHashtag: '#AVozDaLuta',
    postColor: '#000',
    postPopupImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/pop_1.png',
    postGalleryOptions: {
      enterSource: 'venue_3',
      autoAtFriend: true,
      returntoOriginalPage: true,
      hashtag: 'AVozDaLuta',
      caption: 'Estou visitando a exposição #ParadaPreta no kwai, venha se juntar a nós!'
    }
  },
  2: {
    progressTitle: 'Exibição B',
    progressImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/pro_2.png',
    mainBackground: '#FF212B',
    mainImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/back_f_2.png',
    themeTitle: 'O PODER DA BATIDA',
    appointmentTitle: 'O poder da batida',
    buttonBackground: '#FFAE00',
    appointmentDateColor: '#FFD74B',
    postTitle: 'GERAR UM PÔSTER POR FINALIZAR A VISITA',
    bottomImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/bot_2.png',
    postFinalImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/fina_2.png',
    // postFinalImg:'https://s1-12726.ap4r.com/oversea-cc-upload/OCC_nNljZBbT_icon-kwai.jpg',
    postFinalHashtag: '#OPoderDaBatida',
    postPopupImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/pop_2.png',
    postColor: '#FFF',
    postGalleryOptions: {
      enterSource: 'venue_2',
      autoAtFriend: true,
      returntoOriginalPage: true,
      hashtag: 'OPoderDaBatida',
      caption: 'Estou visitando a exposição #ParadaPreta no kwai, venha se juntar a nós!'
    }
  },
  3: {
    progressTitle: 'Exibição D',
    progressImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/pro_3.png',
    mainBackground: '#FFAC08',
    mainImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/back_f_3.png',
    themeTitle: 'DA HISTÓRIA PARA O PRATO',
    appointmentTitle: 'Da história para o prato',
    buttonBackground: '#FE382F',
    appointmentDateColor: 'rgba(255, 90, 83, 1)',
    postTitle: 'GERAR UM PÔSTER POR FINALIZAR A VISITA',
    bottomImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/bot_3.png',
    postFinalImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/fina_4.png',
    // postFinalImg:'https://s1-12726.ap4r.com/oversea-cc-upload/OCC_nNljZBbT_icon-kwai.jpg',
    postFinalHashtag: '#DaHistóriaParaOPrato',
    postPopupImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/pop_3.png',
    postColor: '#000',
    postGalleryOptions: {
      enterSource: 'venue_3',
      autoAtFriend: true,
      returntoOriginalPage: true,
      hashtag: 'DaHistoriaParaOPrato',
      caption: 'Estou visitando a exposição #ParadaPreta no kwai, venha se juntar a nós!'
    }
  },
  4: {
    progressTitle: 'Exibição C',
    progressImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/pro_4.png',
    mainBackground: '#FF72D1',
    mainImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/back_f_4.png',
    themeTitle: 'ICONES DA MODA',
    appointmentTitle: 'Icones da moda',
    buttonBackground: '#00AA51',
    appointmentDateColor: '#00F976',
    postTitle: 'GERAR UM PÔSTER POR FINALIZAR A VISITA',
    bottomImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/bot_4.png',
    postFinalImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/fina_3.png',
    // postFinalImg:'https://s1-12726.ap4r.com/oversea-cc-upload/OCC_nNljZBbT_icon-kwai.jpg',
    postFinalHashtag: '#IconesDaModa',
    postPopupImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/black-month/pop_4.png',
    postColor: '#000',
    postGalleryOptions: {
      enterSource: 'venue_4',
      autoAtFriend: true,
      returntoOriginalPage: true,
      hashtag: 'IconesDaModa',
      caption: 'Estou visitando a exposição #ParadaPreta no kwai, venha se juntar a nós!'
    }
  }
};